<template>
  <Command v-if="wpsClient.token.isSample" @click="copyLink">
    <slot
      v-bind="{
        disabled: false,
        icon: 'content_copy',
        label: t('moreOptions.copyLink'),
        toolTip: t('moreOptions.copyLink'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { posthogKeys } from "@/helpers/constants";
import { usePostHog } from "@/helpers/posthog";
import { useUiVisibilityStore } from "@/stores/uiVisibility";
import { useWpsClient } from "@/wps/client";

import Command from "../command";

const visibilityStore = useUiVisibilityStore();

const { t } = useI18n();
const { capture: capturePosthogEvent } = usePostHog();

const wpsClient = useWpsClient();

async function copyLink(event: MouseEvent) {
  const url = wpsClient.canonicalUrl?.href || window.location?.href;
  await window.navigator.clipboard.writeText(url);

  capturePosthogEvent(posthogKeys.sampleCopyLink);
  document.documentElement.style.setProperty(
    "--tooltip-position-x",
    event.pageX + "px"
  );
  document.documentElement.style.setProperty(
    "--tooltip-position-y",
    event.pageY + "px"
  );

  visibilityStore.setShowTooltipCopyLink(true);
  setTimeout(() => {
    visibilityStore.setShowTooltipCopyLink(false);
  }, 2000);
}
</script>
